<div class="meter-details-container">
  <div class="page-header">
    <h1 class="page-title">My Consents</h1>
    <p class="page-subtitle">View and manage your electricity and gas meters.</p>
  </div>

  <!-- Loading Spinner -->
  @if (isLoading()) {
    <div class="loading-container">
      <div class="loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="loading-text">Loading your meters...</p>
      </div>
    </div>
  } @else {
    <div class="content-container">
      
      <!-- Action Bar -->
      <div class="action-bar">
        <div class="action-bar-left">
          <mat-checkbox 
            [checked]="allMetersSelected()"
            [indeterminate]="someMetersSelected()"
            (change)="toggleAllSelection()"
            class="select-all-checkbox">
            Select All
          </mat-checkbox>
          
          @if (selectedMeters().length > 0) {
            <span class="selection-info">
              {{ selectedMeters().length }} selected
            </span>
          }
        </div>

        <div class="action-bar-middle">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search meters</mat-label>
            <input 
              matInput 
              [ngModel]="searchQuery()" 
              (ngModelChange)="onSearchChange($event)"
              placeholder="Address, meter number, fuel type..."
              autocomplete="off">
            <mat-icon matPrefix>search</mat-icon>
            @if (searchQuery()) {
              <button mat-icon-button matSuffix (click)="clearSearch()" matTooltip="Clear search">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>

        <div class="action-bar-right">
          <button mat-flat-button color="primary" (click)="addNewMeter()">
            <mat-icon>add</mat-icon> Add New
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="downloadAllMeters()"
            [disabled]="meters().length === 0">
            <mat-icon>download</mat-icon> Download All
          </button>
          
          @if (selectedMeters().length > 0) {
            <button mat-stroked-button color="warn" (click)="bulkWithdrawConsent()">
              <mat-icon>key_off</mat-icon> Withdraw ({{ selectedMeters().length }})
            </button>

}
          
          <button mat-icon-button (click)="loadMeters()" [disabled]="isLoading()" matTooltip="Refresh meters">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>

      <!-- Meter Cards with Pagination -->
      @if (paginatedMeterGroups().length > 0) {
        <div class="meter-groups-container">
          @for (group of paginatedMeterGroups(); track trackByGroup($index, group)) {
            <!-- Address Header -->
            <div class="address-group-header">
              <h2 class="address-title">
                <mat-icon class="address-icon">location_on</mat-icon>
                <span class="address-text">{{ group.address }}</span>
                <!-- @if (group.relationship) {
                  <span class="relationship-badge">
                    <mat-icon class="relationship-icon">{{ getRelationshipIcon(group.relationship) }}</mat-icon>
                    <span class="relationship-text">{{ getRelationshipDisplayText(group.relationship) }}</span>
                  </span>
                } -->
                <span class="meter-count d-none d-sm-inline">({{ group.meters.length }} meter{{ group.meters.length > 1 ? 's' : '' }})</span>
              </h2>
            </div>

            <!-- Meter Cards -->
            <div class="meters-grid">
              @for (meter of group.meters; track trackByMeter($index, meter)) {
                <app-meter-card-enhanced
                  [meter]="meter"
                  [selected]="selectedMeterNumbers().has(meter.meterNumber)"
                  (selectionChange)="onMeterSelectionChange(meter.meterNumber, $event)"
                  (share)="shareMeter($event)"
                  (download)="downloadMeter($event)"
                  (withdrawConsent)="withdrawConsent($event)"
                  (shareRevoked)="onShareRevoked()"
                  (revokeShareRequest)="revokeShare($event, meter)"
                  (manageShares)="manageShares($event)">
                </app-meter-card-enhanced>
              }
            </div>
          }
        </div>

        <!-- Pagination -->
        <div class="pagination-container">
          <mat-paginator
            [length]="totalGroups()"
            [pageSize]="pageSize()"
            [pageIndex]="pageIndex()"
            [pageSizeOptions]="[5, 10, 20, 50]"
            (page)="onPageChange($event)"
            showFirstLastButtons
            aria-label="Select page">
          </mat-paginator>
        </div>
      } @else {
        <!-- Empty state -->
        <div class="empty-state-container">
          <mat-card class="empty-state-card">
            <mat-card-content class="empty-state-content">
              <mat-icon class="empty-state-icon">electrical_services</mat-icon>
              <h3 class="empty-state-title">No Meters Found</h3>
              <p class="empty-state-message">
                @if (searchQuery()) {
                  No meters match your search criteria. Try a different search term.
                } @else {
                  You haven't added any meters yet. Click the "Add New" button to get started.
                }
              </p>
              <button mat-raised-button color="primary" (click)="addNewMeter()">
                <mat-icon>add</mat-icon> Add Your First Meter
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  }
</div>
